
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnItemsGrid extends Serenity.EntityGrid<JobWorkReturnItemsRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkReturnItems'; }
        protected getDialogType() { return JobWorkReturnItemsDialog; }
        protected getIdProperty() { return JobWorkReturnItemsRow.idProperty; }
        protected getInsertPermission() { return JobWorkReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReturnItemsRow.localTextPrefix; }
        protected getService() { return JobWorkReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}